{
  "en": {
    "aiDocumentQa": {
      "buttons": {
        "chooseFile": "Choose File",
        "loadMore": "Load more"
      },
      "confirm": {
        "deleteDocumentChat": {
          "text": "This action cannot be undone. The document and all chat history will be permanently deleted.",
          "title": "Delete Document Chat?"
        }
      },
      "hints": {
        "documentIsBeingProcessed": "Document is being processed...",
        "dropFile": "Drop PDF file or",
        "fileLimit": "(max. 10MB)"
      },
      "labels": {
        "words": "{count} words"
      },
      "paragraphs": {
        "intro": "Upload a document and use AI to summarize it, create question-answer pairs for flashcards, or get answers to your questions about its content. Note: Images and tables in documents are not readable for the AI."
      },
      "statusMessages": {
        "indexing": "Knowledgebase is being indexed",
        "indexingStatus": "Indexing"
      }
    }
  }
}
